import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c0dec01a = () => interopDefault(import('..\\pages\\coming-soon\\index.vue' /* webpackChunkName: "pages_coming-soon_index" */))
const _22fe24fc = () => interopDefault(import('..\\pages\\dashboard.vue' /* webpackChunkName: "pages_dashboard" */))
const _040e1d26 = () => interopDefault(import('..\\pages\\eligibility\\index.vue' /* webpackChunkName: "pages_eligibility_index" */))
const _f59ecb20 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _826c3746 = () => interopDefault(import('..\\pages\\failed\\index.vue' /* webpackChunkName: "pages_failed_index" */))
const _18520dd9 = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _d4418d2a = () => interopDefault(import('..\\pages\\settings.vue' /* webpackChunkName: "pages_settings" */))
const _e2799fe8 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _4f7156c0 = () => interopDefault(import('..\\pages\\account\\forgot-password.vue' /* webpackChunkName: "pages_account_forgot-password" */))
const _0ab8a1e4 = () => interopDefault(import('..\\pages\\account\\login.vue' /* webpackChunkName: "pages_account_login" */))
const _68dbc521 = () => interopDefault(import('..\\pages\\account\\my-account.vue' /* webpackChunkName: "pages_account_my-account" */))
const _62307c78 = () => interopDefault(import('..\\pages\\account\\register.vue' /* webpackChunkName: "pages_account_register" */))
const _829b96a4 = () => interopDefault(import('..\\pages\\account\\register-success.vue' /* webpackChunkName: "pages_account_register-success" */))
const _79fbbd7b = () => interopDefault(import('..\\pages\\claim\\search-claim.vue' /* webpackChunkName: "pages_claim_search-claim" */))
const _79e34beb = () => interopDefault(import('..\\pages\\claim\\submit-claim.vue' /* webpackChunkName: "pages_claim_submit-claim" */))
const _23c5c9e0 = () => interopDefault(import('..\\pages\\enrollment\\form.vue' /* webpackChunkName: "pages_enrollment_form" */))
const _b5bc1270 = () => interopDefault(import('..\\pages\\enrollment\\patient-information.vue' /* webpackChunkName: "pages_enrollment_patient-information" */))
const _eab48f10 = () => interopDefault(import('..\\pages\\enrollment\\prescriber-hub-information.vue' /* webpackChunkName: "pages_enrollment_prescriber-hub-information" */))
const _97cb5960 = () => interopDefault(import('..\\pages\\enrollment\\prescriber-information.vue' /* webpackChunkName: "pages_enrollment_prescriber-information" */))
const _6fbc8ee7 = () => interopDefault(import('..\\pages\\enrollment\\success.vue' /* webpackChunkName: "pages_enrollment_success" */))
const _00099647 = () => interopDefault(import('..\\pages\\enrollment\\success-modal.vue' /* webpackChunkName: "pages_enrollment_success-modal" */))
const _5dfc3d11 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _5e0a5492 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _5e268394 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _5e349b15 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _da3b0f5c = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _004d51bc = () => interopDefault(import('..\\pages\\patient-information\\patient-search.vue' /* webpackChunkName: "pages_patient-information_patient-search" */))
const _416a7c3a = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/coming-soon",
    component: _c0dec01a,
    name: "coming-soon"
  }, {
    path: "/dashboard",
    component: _22fe24fc,
    name: "dashboard"
  }, {
    path: "/eligibility",
    component: _040e1d26,
    name: "eligibility"
  }, {
    path: "/error",
    component: _f59ecb20,
    name: "error"
  }, {
    path: "/failed",
    component: _826c3746,
    name: "failed"
  }, {
    path: "/not-eligible",
    component: _18520dd9,
    name: "not-eligible"
  }, {
    path: "/settings",
    component: _d4418d2a,
    name: "settings"
  }, {
    path: "/unlock",
    component: _e2799fe8,
    name: "unlock"
  }, {
    path: "/account/forgot-password",
    component: _4f7156c0,
    name: "account-forgot-password"
  }, {
    path: "/account/login",
    component: _0ab8a1e4,
    name: "account-login"
  }, {
    path: "/account/my-account",
    component: _68dbc521,
    name: "account-my-account"
  }, {
    path: "/account/register",
    component: _62307c78,
    name: "account-register"
  }, {
    path: "/account/register-success",
    component: _829b96a4,
    name: "account-register-success"
  }, {
    path: "/claim/search-claim",
    component: _79fbbd7b,
    name: "claim-search-claim"
  }, {
    path: "/claim/submit-claim",
    component: _79e34beb,
    name: "claim-submit-claim"
  }, {
    path: "/enrollment/form",
    component: _23c5c9e0,
    name: "enrollment-form"
  }, {
    path: "/enrollment/patient-information",
    component: _b5bc1270,
    name: "enrollment-patient-information"
  }, {
    path: "/enrollment/prescriber-hub-information",
    component: _eab48f10,
    name: "enrollment-prescriber-hub-information"
  }, {
    path: "/enrollment/prescriber-information",
    component: _97cb5960,
    name: "enrollment-prescriber-information"
  }, {
    path: "/enrollment/success",
    component: _6fbc8ee7,
    name: "enrollment-success"
  }, {
    path: "/enrollment/success-modal",
    component: _00099647,
    name: "enrollment-success-modal"
  }, {
    path: "/errors/400",
    component: _5dfc3d11,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _5e0a5492,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _5e268394,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _5e349b15,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _da3b0f5c,
    name: "errors-500"
  }, {
    path: "/patient-information/patient-search",
    component: _004d51bc,
    name: "patient-information-patient-search"
  }, {
    path: "/",
    component: _416a7c3a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
